module.exports = __webpack_public_path__ + "img/wav.ae57e86a.svg";